import React, { MutableRefObject, useMemo } from "react";
import {
  APP_NAME_KNOCKKNOCK,
  APP_NAME_THROO,
  ORDER_CANCLE_STATUS,
  ORDER_COM_DEL_STATUS,
  ORDER_COM_STATUS,
  OrderItemType,
  THROO_ORDER_STATE_COLOR,
} from "../../../recoil/type";
import KnockOrder from "../../order/knockknock/KnockOrder";
import ThrooOrder from "../../order/throo/ThrooOrder";

interface OrderListProps {
  preparedList: OrderItemType[];
  checkedList: OrderItemType[];
  completedList: OrderItemType[];
  status: number;
  completeStatus: number;
  isDetail: boolean;
  itemRefs: MutableRefObject<(HTMLDivElement | null)[]>;
}

const OrderList = ({
  preparedList,
  checkedList,
  completedList,
  status,
  completeStatus,
  isDetail,
  itemRefs,
}: OrderListProps) => {
  const OrderList = useMemo(() => {
    //실제로 화면에 표시될 주문 리스트

    let orderList: OrderItemType[] = [];

    if (status === 0) {
      //접수대기일 경우

      orderList = preparedList;
    } else if (status === 1) {
      //처리중일 경우

      orderList = checkedList;
    } else if (status === 2) {
      // 완료/취소일 경우

      if (completeStatus === 0) {
        //(필터) 전체
        orderList = completedList;
      } else if (completeStatus === 1) {
        //(필터) 완료
        orderList = completedList.filter((order) => {
          if (order.app_name === APP_NAME_KNOCKKNOCK) {
            return (
              order.child.order_status === ORDER_COM_STATUS ||
              order.child.order_status === ORDER_COM_DEL_STATUS
            );
          } else if (order.app_name === APP_NAME_THROO) {
            return order.state_color === THROO_ORDER_STATE_COLOR.CONCLUDE;
          }

          return false;
        });
      } else if (completeStatus === 2) {
        //(필터) 취소
        orderList = completedList.filter((order) => {
          if (order.app_name === APP_NAME_KNOCKKNOCK) {
            return order.child.order_status === ORDER_CANCLE_STATUS;
          } else if (order.app_name === APP_NAME_THROO) {
            return (
              order.state_color === THROO_ORDER_STATE_COLOR.STORE_CANCELLED ||
              order.state_color === THROO_ORDER_STATE_COLOR.CUSTOMER_CANCELLED
            );
          }
          return false;
        });
      }
    }

    return orderList.length === 0 ? (
      <div className="orderListWrap noDataListWrap">
        <div className="noDataList">
          <div className="titleIcon">
            <img
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_not_order.svg`}
              alt="img"
            />
          </div>
          <div className="title">
            <h3>주문 내역이 없습니다</h3>
          </div>
        </div>
      </div>
    ) : (
      <div className="orderListWrap">
        {orderList.map((order, index) => {
          if (order.app_name === APP_NAME_KNOCKKNOCK) {
            //TODO 채널타입
            return (
              <KnockOrder
                key={status + ":" + index}
                ref={(el) => (itemRefs.current[index] = el)}
                order={order}
                detailStatus={isDetail}
                index={index}
              />
            );
            // }
          } else if (order.app_name === APP_NAME_THROO) {
            return (
              <ThrooOrder
                key={status + ":" + index}
                order={order}
                isDetail={isDetail}
              />
            );
          }
        })}
      </div>
    );
  }, [
    preparedList,
    checkedList,
    completedList,
    status,
    completeStatus,
    isDetail,
  ]);

  return OrderList;
};
export default OrderList;
